<div class="form-container">
  <app-email-signin></app-email-signin>
</div>
<app-provider-logins></app-provider-logins>
